import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { openBillingPortal } from '../../utils/billingPortal';

const Header = ({ user, handleGoogleSignIn, handleSignOut, lightBackground, minimal = false, ctaLabel = "Get Your Product Photos", isLandingPage = false }) => {
    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => setMenuOpen(false);

    const handleBillingClick = (e) => {
        e.preventDefault();
        closeMenu();
        openBillingPortal({
            user,
            onUnauthenticated: handleGoogleSignIn,
        });
    };

    return (
        <div className={`header-wrapper ${lightBackground ? 'header-wrapper-light' : ''}`}>
        <header>
            <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
                <h1 className="logo" style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                    Jewl AI 💎
                </h1>
            </Link>
            {!minimal && (
                <div className="header-right">
                    <nav className={`header-nav ${menuOpen ? 'header-nav-open' : ''}`}>
                        <div className="header-nav-links">
                            <a href="mailto:support@jewlai.com" className="header-text-button" onClick={closeMenu}>
                                Contact
                            </a>
                            <Link to="/pricing" className="header-text-button pricing-link" onClick={closeMenu}>
                                Pricing
                            </Link>
                            {user && (
                                <a
                                    href="#billing"
                                    className="header-text-button"
                                    onClick={handleBillingClick}>
                                    Billing
                                </a>
                            )}
                            {isLandingPage && (
                                <Link to="/tryon" className="header-text-button header-product-photos-mobile" onClick={closeMenu}>
                                    Get Your Product Photos
                                </Link>
                            )}
                            <Link to="/tryon" className="header-cta-button header-cta-button-mobile" onClick={closeMenu}>
                                {ctaLabel}
                            </Link>
                        </div>
                    </nav>
                    {user ? (
                        <button 
                            onClick={handleSignOut} 
                            className="header-text-button header-login-link">
                            Log out →
                        </button>
                    ) : (
                        <button 
                            onClick={handleGoogleSignIn} 
                            className="header-text-button header-login-link header-google-login">
                            <svg className="google-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                            </svg>
                            Log in
                        </button>
                    )}
                    <Link to="/tryon" className="header-cta-button">
                        {ctaLabel}
                    </Link>
                    <button 
                        className={`hamburger-button ${menuOpen ? 'hamburger-open' : ''}`}
                        onClick={() => setMenuOpen(!menuOpen)}
                        aria-label={menuOpen ? "Menü schließen" : "Menü öffnen"}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>
            )}
        </header>
        </div>
    );
};

export default Header;
